import { REGISTER_CENTER, globalConstants } from "../constants";
import { postRequestWithFiles } from "../system/server-call";
import responseHandler from "../system/server-response-handler";

const registerCenter = (data) => {
  return postRequestWithFiles(
    `/${globalConstants.VERSION}/${REGISTER_CENTER}`,
    data,
    false
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const centerService = {
  registerCenter,
};
